import { useFormik } from 'formik'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import Checkbox from '../../../Inputs/Checkbox/Checkbox'
import Money from '../../../Money/Money'
import Typography from '../../../Typography/Typography'

import { documentSlugs } from 'components/Modal/DocumentPopupWindow/slugs'
import './Reservation.scss'

const Reservation = ({ data, loading, onPayment, setSlug }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            checkBox: false,
        },
        validationSchema: Yup.object({
            checkBox: Yup.boolean().oneOf([true], intl.formatMessage({ id: 'forms.register.checkBoxNotChecked' })),
        }),
        onSubmit: () => {
            onPayment()
            return null
        },
    })

    const onSitePrice = data?.application_prices?.find((item) => item.application === 'Client')?.price

    //TODO finish this component and add i18n

    return (
        <form className="d-flex flex-column gap-3" onSubmit={formik.handleSubmit}>
            <div className={'basket-reservation d-flex align-items-center justify-content-between'}>
                <div className="price-wrapper d-flex">
                    <div className="d-flex flex-column">
                        <Typography color={'basePrimary'} variant={'h3'}>
                            {intl.formatMessage({ id: 'basket.totalPriceReservation' })}
                        </Typography>
                        <Typography color={'basePrimary'} variant={'label'}>
                            {intl.formatMessage({ id: 'basket.textOnlineReservation' })}
                        </Typography>
                    </div>
                    <Typography color={'basePrimary'} variant={'h3'}>
                        <Money amount={data?.price} currency={data?.currency} />
                    </Typography>
                </div>
                <div className="btns-wrapper d-flex align-items-center">
                    <Checkbox
                        name={'checkBox'}
                        id={'checkBox'}
                        color={'white'}
                        error={formik?.errors?.checkBox}
                        touched={formik?.touched?.checkBox}
                        {...formik.getFieldProps('checkBox')}
                        label={
                            <a
                                onClick={() => setSlug({ slug: documentSlugs.conditions })}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {intl.formatMessage(
                                    { id: 'forms.register.checkboxLabel' },
                                    { span: (chunks) => <span className="text-decoration-underline">{chunks}</span> }
                                )}
                            </a>
                        }
                        onBlur={formik?.handleBlur}
                        disabled={loading}
                        className={'d-none d-md-block'}
                    />
                    <ButtonCinestar
                        variant={'primary-v1'}
                        disabled={loading}
                        className={'text-uppercase'}
                        type={'submit'}
                    >
                        {intl.formatMessage({ id: 'basket.reservationBtn' })}
                    </ButtonCinestar>
                </div>
            </div>
            <Checkbox
                name={'checkBox'}
                id={'checkBox'}
                color={'white'}
                error={formik?.errors?.checkBox}
                touched={formik?.touched?.checkBox}
                {...formik.getFieldProps('checkBox')}
                label={
                    <a onClick={() => setSlug({ slug: documentSlugs.conditions })} target="_blank" rel="noreferrer">
                        {intl.formatMessage(
                            { id: 'forms.register.checkboxLabel' },
                            { span: (chunks) => <span className="text-decoration-underline">{chunks}</span> }
                        )}
                    </a>
                }
                onBlur={formik?.handleBlur}
                disabled={loading}
                className={'d-md-none mb-2 pb-1'}
            />
        </form>
    )
}

export default Reservation
